import styled from 'styled-components';
import PropTypes from 'prop-types';

const Text = styled.div`
  color: ${props => props.color};
  font-size: ${props => props.size}px;
  text-align: ${props => props.align};
  font-weight: ${props => props.bold ? 'bold' : 'normal'};
  line-height: ${props => props.lineHeight};
  text-shadow: ${props => props.shadow ? '0 0 2px #e6e6e6' : 'none'};
  text-decoration: ${props => props.underline ? 'underline' : 'none'};
  cursor: ${props => props.cursor ? props.cursor : 'default'};
  font-family: Tahoma;
`;

Text.defaultProps = {
  color: '#8d8d8d',
  size: 14,
  align: 'left',
  bold: false,
  lineHeight: 1.3,
  shadow: false,
  fontFamily: 'Tahoma',
  underline: false,
  cursor: 'normal',
}

Text.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  align: PropTypes.string,
  bold: PropTypes.bool,
  lineHeight: PropTypes.number,
  shadow: PropTypes.bool,
  cursor: PropTypes.string,
}

export default Text;